import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { publicAPI } from '@Base/plugins/axios.js';
import langService from '@Base/services/langService.js';

Vue.use(VueI18n);
/** Expone $trad para poder ser usado como sustituto de $t en los componentes, 
 * permite utilizar un texto de fallback definido por el usuario */
Vue.prototype.$trad = trad;

const messages = {
    '': {}
}

/**
 * Traduce un texto a partir de una llave de traducción,
 * si no existe la llave, devuelve el texto de fallback
 */
export function trad(str, fallbackStr){
  return i18n.te(str) ? i18n.t(str) : fallbackStr; 
}

export const i18n = new VueI18n({
  locale: '',
  fallbackLocale: 'es-ES',
  messages //set locale messages
});

function setI18nLanguage (lang){
  i18n.locale = lang
  publicAPI.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang)
  return lang;
}

// function saveToLocalStorage(data, traducciones){
//   let langName = data.language + '.' + data.version
//   window.localStorage.setItem(langName, JSON.stringify(traducciones))
// }

function saveToLocalStorageByApp(data, app, traducciones){
  let langName = data.language + '.' + app.id + '.' + data.version;

  let deleteKey = Object.keys(window.localStorage).find(key => key.includes(`${data.language}.${app.id}`) );
  if(deleteKey) window.localStorage.removeItem(deleteKey);

  window.localStorage.setItem(langName, JSON.stringify(traducciones))
}

// function restoreFromLocalStorage(lang){
//   let key = Object.keys(window.localStorage).find(key => key.includes(lang) )

//   return key ? { key, value: JSON.parse(window.localStorage.getItem(key)) } : null
// }

function restoreFromLocalStorageByApp(lang, app){
  let key = Object.keys(window.localStorage).find(key => key.includes(`${lang}.${app.id}`) )

  return key ? { key, value: JSON.parse(window.localStorage.getItem(key)) } : null
}

function restoreFromLocalStorageByLang(lang){
  let key = Object.keys(window.localStorage).filter(key => key.includes(`${lang}`) )

  return key 
    ? key.map(item => {
      return { key: item, value: JSON.parse(window.localStorage.getItem(item)) }
    })
    : null

  // { key, value: JSON.parse(window.localStorage.getItem(key)) } : null
}

export function loadLanguageAsync(lang){
  const langApps = [
    {
      id: 50, //Auditoria
      name: 'Auditoria',
    },
    {
      id: 14, //UEmpresa
      name: 'UEmpresa',
    }
  ]

  // If same language
  if(i18n.locale === lang){
    return Promise.resolve(setI18nLanguage(lang));
  }

  langApps.forEach(app => {
    let localLang = restoreFromLocalStorageByApp(lang, app);
    let auxVersion = localLang ? localLang.key.split('.')[2] : 0;

    /*langService.getLang(lang, app.id, auxVersion).then(resp => {
      if(resp.status == 204 ||  Object.keys(resp.data).length === 0) {
        i18n.setLocaleMessage(lang, localLang.value);
        return setI18nLanguage(lang)
  
      } else {    
        // Guardamos las traducciones en localStorage
        let traducciones = {};
        JSON.parse(resp.data.traducciones).map( (trad) => {
          Object.entries(trad).forEach( ([key, value]) => {
            traducciones[key] = value;
          })
        })
        saveToLocalStorageByApp(resp.data, app, traducciones);

        // Construimos las traducciones con todas las guardadas
        let auxTraducciones = {}
        restoreFromLocalStorageByLang(lang).forEach(item => 
          auxTraducciones = {...auxTraducciones, ...item.value} 
        );

        // Le pasamos a i18n las traducciones a usar
        i18n.setLocaleMessage(resp.data.language, auxTraducciones);
      }
    }); //Fin getLang*/
  })
  

  return Promise.resolve(setI18nLanguage(lang))
  
  

}

export default i18n